import { render, staticRenderFns } from "./ModalProject.vue?vue&type=template&id=3bebb7e7&scoped=true&"
import script from "./ModalProject.vue?vue&type=script&lang=js&"
export * from "./ModalProject.vue?vue&type=script&lang=js&"
import style0 from "./ModalProject.vue?vue&type=style&index=0&id=3bebb7e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bebb7e7",
  null
  
)

export default component.exports